export const letterSpacings = {
  "tighter": "-0.05em",
  "tight": "-0.025em",
  "normal": "0",
  "wide": "0.025em",
  "wider": "0.05em",
  "widest": "0.1em"
};
export const lineHeights = {
  "3": "0.75rem",
  "4": "1rem",
  "5": "1.25rem",
  "6": "1.5rem",
  "7": "1.75rem",
  "8": "2rem",
  "9": "2.25rem",
  "10": "2.5rem",
  "11": "2.75rem",
  "normal": "normal",
  "none": "100%",
  "shorter": "125%",
  "short": "137.5%",
  "base": "150%",
  "tall": "162.5%",
  "taller": "200%",
  "3-5": "0.875rem",
  "4-5": "1.125rem",
  "5-5": "1.375rem",
  "6-5": "1.625rem"
};
export const fonts = {
  "heading": "Lato, -apple-system, BlinkMacSystemFont, '\"Segoe UI\"', Helvetica, Arial, sans-serif, '\"Apple Color Emoji\"', '\"Segoe UI Emoji\"', '\"Segoe UI Symbol\"'",
  "body": "Lato, -apple-system, BlinkMacSystemFont, '\"Segoe UI\"', Helvetica, Arial, sans-serif, '\"Apple Color Emoji\"', '\"Segoe UI Emoji\"', '\"Segoe UI Symbol\"'",
  "mono": "SF Mono, Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace",
  "fallback": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\""
};
export const fontWeights = {
  "hairline": "100",
  "thin": "200",
  "light": "300",
  "normal": "400",
  "regular": "400",
  "medium": "500",
  "semibold": "600",
  "bold": "700",
  "extrabold": "800",
  "black": "900"
};
export const fontSizes = {
  "3xs": "0.5rem",
  "2xs": "0.625rem",
  "xs": "0.75rem",
  "sm": "0.875rem",
  "md": "1rem",
  "lg": "1.125rem",
  "xl": "1.25rem",
  "2xl": "1.375rem",
  "3xl": "1.5rem",
  "4xl": "1.75rem",
  "5xl": "2rem",
  "6xl": "2.25rem",
  "7xl": "2.5rem",
  "8xl": "2.75",
  "9xl": "3rem"
};